import React, { useMemo } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';

import { useAppStore } from 'store/useAppStore';

const ALL_ROLES = {
	value: '',
	name: 'Visi' 
};

const ADMIN_ROLES = {
	value: 'admin,employee',
	name: 'Administrācija'
};

const TEACHER_ROLES = {
	value: 'teacher',
	name: 'Pedagogi'
};

const STUDENT_ROLES = {
	value: 'student',
	name: 'Studenti'
};

const PARENT_ROLES = {
	value: 'parent',
	name: 'Vecāki'
};

const Role = ({ role, active, onChange }) => {
	// Concat role's classname
	const cls = classnames(
		'text-sm font-semibold rounded-full cursor-pointer hover:text-neutral-700 dark:hover:text-neutral-100 transition-colors',
		role.value === active ? 'text-neutral-700 dark:text-neutral-100' : 'text-neutral-400 dark:text-neutral-500'
	);

	// Handle role selection
	const onClick = () => onChange({ name: 'role', value: role.value });
	
	return (
		<div className={cls} onClick={onClick}>
			{role.name}
		</div>
	);
};

const Search = ({ search, onChange }) => {
	// Use app's store
	const user = useAppStore(state => state.user);

	// Store flag if user is an admin
	const isAdmin = useMemo(() => ['admin', 'employee'].includes(user.role), [user]);

	// Get available roles depending on user's role
	const roles = useMemo(() => {
		switch (user.role) {
		case 'admin':
		case 'employee':
			return [
				ALL_ROLES,
				ADMIN_ROLES,
				TEACHER_ROLES,
				STUDENT_ROLES,
				PARENT_ROLES
			];
		case 'teacher':
			return [
				ALL_ROLES,
				ADMIN_ROLES,
				TEACHER_ROLES,
				STUDENT_ROLES
			];
		case 'student':
			return [
				ALL_ROLES,
				ADMIN_ROLES,
				TEACHER_ROLES,
				PARENT_ROLES
			];
		case 'parent':
			return [
				ALL_ROLES,
				ADMIN_ROLES,
				STUDENT_ROLES
			];
		default:
			return [ALL_ROLES];
		}
	}, [user]);

	return (
		<div className="pt-3 px-3 pb-1 space-y-2">
			<input
				name="name"
				type="text"
				placeholder="Meklēt"
				className="px-3 h-10 bg-neutral-100 dark:bg-neutral-700 rounded-lg text-neutral-700 dark:text-neutral-100 w-full placeholder:text-neutral-500 dark:placeholder:text-neutral-400 text-sm transition-colors"
				value={search.name}
				onChange={onChange}
			/>

			<Show if={isAdmin}>
				<div className="flex flex-wrap gap-2">
					{roles.map(role =>
						<Role
							key={role.value}
							role={role}
							active={search.role}
							onChange={onChange}
						/>
					)}
				</div>
			</Show>
		</div>
	);
};

export default Search;